<template>
    <div v-if="question" class="q-wrap">
        <div class="q-input">
            <div class="slider-block">
                <div class="slider-val-row">
                    <span class="slider-val">{{ answer }}</span>
                    <span v-if="unit" class="slider-unit">{{ unit }}</span>
                </div>
                <div class="slider-track-wrap">
                    <input type="range" class="q-range" :min="question.min" :max="question.max" :step="1"
                        :style="{ '--pct': pct + '%' }" v-model.number="answer">
                    <div class="slider-limits">
                        <span>{{ question.min }}</span>
                        <span>{{ question.max }}</span>
                    </div>
                </div>
                <kimsa-text-field v-if="question.comment" class="mt-4" @change="comment = $event" :value="comment"
                    :placeholder="$t('common.load_comment')" force-value dense no-elevation />
            </div>
        </div>
        <div class="q-actions">
            <v-btn block large depressed color="primary" class="black--text q-next" :disabled="!answer"
                @click="sendAnswer">
                {{ $t('common.next') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import KimsaTextField from '../../common/inputs/KimsaTextField.vue'
export default {
    components: { KimsaTextField },
    props: {
        question: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            answer: Math.round((this.question.min + this.question.max) / 2),
            comment: '',
        }
    },
    computed: {
        pct(vm = this) {
            const { min, max } = vm.question
            if (max === min) return 0
            return ((vm.answer - min) / (max - min)) * 100
        },
        unit(vm = this) {
            return vm.question.unit ? vm.$t(vm.question.unit) : ''
        },
    },
    methods: {
        sendAnswer() {
            const vm = this;
            vm.$emit('click:next', vm.question, { value: vm.answer, comment: vm.comment })
        },
    },
}
</script>

<style scoped>
.q-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
    padding-top: 20px;
}

.q-input {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
}

.slider-block {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.slider-val-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
}

.slider-val {
    font-size: 44px;
    font-weight: 800;
    line-height: 1;
    color: var(--v-secondary-base);
}

.theme--light .slider-val {
    color: var(--v-accent-base);
}

.slider-unit {
    font-size: 16px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
}

.slider-track-wrap {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.q-range {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background: linear-gradient(to right,
            var(--v-secondary-base) var(--pct, 50%),
            var(--v-outline-base) var(--pct, 50%));
    outline: none;
    cursor: pointer;
}

.theme--light .q-range {
    background: linear-gradient(to right,
            var(--v-accent-base) var(--pct, 50%),
            var(--v-outline-base) var(--pct, 50%));
}

.q-range::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--v-secondary-base);
    border: 3px solid var(--v-surface-base);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;
}

.theme--light .q-range::-webkit-slider-thumb {
    background: var(--v-accent-base);
}

.q-range::-moz-range-thumb {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--v-secondary-base);
    border: 3px solid var(--v-surface-base);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    cursor: pointer;
}

.theme--light .q-range::-moz-range-thumb {
    background: var(--v-accent-base);
}

.slider-limits {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
}

.q-actions {
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 8px;
}

.q-next {
    border-radius: 12px;
    font-weight: 700;
    text-transform: none;
    letter-spacing: 0;
}
</style>
